
import { defineComponent } from 'vue'
import { APIClient } from '@/lib/api-client'
import { Campaign, Order, OrderDetail, Variant } from '@/types'
import { formatPrice } from '@/lib/formatters'

import SuzuriHeader from '@/components/SuzuriHeader.vue'

interface Data {
  campaign: Campaign | null;
  order: Order | null;
}

export default defineComponent({
  components: {
    SuzuriHeader
  },
  data (): Data {
    return {
      campaign: null,
      order: null
    }
  },
  computed: {
    campaignId (): number {
      const id = location.pathname.match('campaigns/(\\d+)/orders')
      return id ? +id[1] : 0
    },
    orderId (): number {
      const id = location.pathname.match('orders/(\\d+)$')
      return id ? +id[1] : 0
    },
    orderDetails (): OrderDetail[] {
      return this.order ? this.order.placements.map(p => p.orderDetails).flat() : []
    },
    tweetUrl (): string {
      if (this.campaign) {
        const url = location.origin + `/squeegee/campaigns/${this.campaign.id}`
        let text = `${this.campaign.name} ${this.$t('item-name.' + this.campaign.item.name + '.short')}を予約したよ。`
        if (this.campaign.user.twitterName) {
          text += ` @${this.campaign.user.twitterName}`
        }
        const query = new URLSearchParams({ url, text, hashtags: 'SUZURIのシルクスクリーン' })

        return `https://x.com/share?${query}`
      } else {
        return ''
      }
    },
    messageHeading (): string {
      return this.campaign && this.campaign.sample ? 'サンプル発注を申請しました' : 'ご予約ありがとうございます!'
    }
  },
  async mounted () {
    try {
      const [campaign, order] = await Promise.all([
        APIClient.get<Campaign>(`campaigns/${this.campaignId}`).then(res => res.data),
        APIClient.get<Order>(`campaigns/${this.campaignId}/orders/${this.orderId}`).then(res => res.data)
      ])

      this.campaign = campaign
      this.order = order
    } catch (e) {
      location.href = '/'
    }
  },
  methods: {
    variantThumbnail (variant: Variant): string {
      return variant.prints[0].thumbnailUrls[0].url
    },
    formatPrice
  }
})
